import { render, staticRenderFns } from "./fanxxy.vue?vue&type=template&id=4297cc38&scoped=true&"
import script from "./fanxxy.vue?vue&type=script&lang=js&"
export * from "./fanxxy.vue?vue&type=script&lang=js&"
import style0 from "./fanxxy.vue?vue&type=style&index=0&id=4297cc38&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4297cc38",
  null
  
)

export default component.exports